import { handleActions } from 'redux-actions';
import _ from 'lodash';

import {
	AddTheme,
	AddPlugin,
	RemovePlugin,
	RemoveAllPlugins,
	PreviewTheme,
	AddThemeTag,
	closePreviewTheme
} from '../actions/actions';

export const userChoiceReducer = handleActions(
	{
		[AddPlugin](state, { payload: data }) {
			// Get selected plugins.
			var selectedPlugins = [ ...state.selectedPlugins ];
			// Add the new value.
			!_.includes(selectedPlugins, data.id) ? selectedPlugins.push( data.id ) : ''

			return Object.assign({}, state, {
				selectedPlugins: selectedPlugins
			});
		},

		[AddThemeTag](state, { payload: data }) {
			// Get selected plugins.
			var selectedThemeTags = [ ...state.selectedThemeTags ];
			// Add the new value.
			!_.includes(selectedThemeTags, data.tag) ? selectedThemeTags.push( data.tag ) : ''

			return Object.assign({}, state, {
				selectedThemeTags: selectedThemeTags
			});
		},

		[RemovePlugin](state, { payload: data }) {
			// Get selected plugins.
			var selectedPlugins = [ ...state.selectedPlugins ];

			return Object.assign({}, state, {
				selectedPlugins: _.pull( selectedPlugins, data.id )
			});
		},

		[RemoveAllPlugins](state, {}) {
			// Get selected plugins.
			var selectedPlugins = state.selectedPlugins;

			return Object.assign({}, state, {
				selectedPlugins: []
			});
		},

		[AddTheme](state, { payload: data }) {
			return Object.assign({}, state, {
				selectedTheme: data.id
			});
		},

		[PreviewTheme](state, { payload: data }) {
			return Object.assign({}, state, {
				previewTheme: data.id
			});
		},

		[closePreviewTheme](state, { payload: data }) {
			return Object.assign({}, state, {
				previewTheme: false
			});
		},
	},
	{
		previewTheme: {},
		selectedTheme: false,
		selectedPlugins: [],
		selectedThemeTags: [],
	}
);
